import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Hook from './components/Hook';
import Comparison from './components/Comparison';
import WhatsInside from './components/WhatsInside';
import Authority from './components/Authority';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen font-sans bg-jeruel-offwhite selection:bg-jeruel-soft selection:text-jeruel-primary">
      <Navbar />
      <main>
        <Hero />
        <Hook />
        <Comparison />
        <WhatsInside />
        <Authority />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;